var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { ExploreStateModel } from './explore.state.model';
import { Load, LoadSuccess, SortSearchResults, ResetSearchResults, CheckSearchResult, SetCheckedSearchResults, SelectCategory, Search, SetSearching, ResetExplore } from './explore.actions';
import { ExploreService } from '../explore.service';
import { BookmarksService, BookmarkCategory } from 'src/app/bookmarks/bookmarks.service';
import { finalize } from 'rxjs/operators';
import { bookmarkSortTitleAsc } from 'src/app/bookmarks/components/bookmarks-sort/bookmarks-sort.component';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { exploreMenu } from '../data/explore-menu';
var categories = exploreMenu.categories;
var initialState = {
    query: '',
    loading: true,
    searching: false,
    searchResults: [],
    sort: bookmarkSortTitleAsc,
    checkedSearchResults: [],
    selectedCategory: null
};
var ExploreState = /** @class */ (function () {
    function ExploreState(exploreService, bookmarksService, store) {
        this.exploreService = exploreService;
        this.bookmarksService = bookmarksService;
        this.store = store;
    }
    ExploreState.getSearchResults = function (state) {
        if (state.searching) { // searching: natural order
            return state.searchResults;
        }
        else { // explicit sort
            var _a = state.sort, ascending_1 = _a.ascending, field_1 = _a.field, alias_1 = _a.alias;
            return state.searchResults.sort(function (a, b) {
                var aValue = a[field_1] || a[alias_1] || '';
                var bValue = b[field_1] || b[alias_1] || '';
                return ((ascending_1) ? 1 : -1) * aValue.localeCompare(bValue, [], { sensitivity: 'base' });
            });
        }
    };
    ExploreState.getCheckedSearchResults = function (state) {
        return state.checkedSearchResults;
    };
    ExploreState.getLoading = function (state) {
        return state.loading;
    };
    ExploreState.getSort = function (state) {
        return state.sort;
    };
    ExploreState.getSelectedCategory = function (state) {
        return state.selectedCategory;
    };
    ExploreState.getSearchQuery = function (state) {
        return state.query;
    };
    ExploreState.prototype.load = function (context, _a) {
        var category = _a.category;
        // Loading
        context.patchState({ loading: true });
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        // Special case for community bookmarks
        var results$ = category === BookmarkCategory.Public
            ? this.bookmarksService.getPublicBookmarks()
            : this.exploreService.getAnatomyCategory('', category, lang);
        results$
            .pipe(finalize(function () {
            context.patchState({ loading: false });
        }))
            .subscribe(function (searchResults) {
            // id normalization
            searchResults.forEach(function (result) {
                if (result.type === 'module') {
                    result.id = result.module_name.replace('.json', '');
                }
            });
            context.dispatch(new LoadSuccess(searchResults));
        });
    };
    ExploreState.prototype.search = function (context, _a) {
        var query = _a.query;
        context.patchState({
            query: query,
            searching: true,
            loading: true
        });
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        // search category modules
        this.exploreService.search(query, [], lang)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (bookmarks) { return context.dispatch(new LoadSuccess(bookmarks)); });
    };
    ExploreState.prototype.setSearching = function (context, _a) {
        var searching = _a.searching;
        context.patchState({
            searching: searching
        });
    };
    ExploreState.prototype.loadSuccess = function (_a, _b) {
        var patchState = _a.patchState;
        var searchResults = _b.searchResults;
        patchState({
            searchResults: searchResults
        });
    };
    ExploreState.prototype.sortSearchResults = function (context, action) {
        var searchResults = context.getState().searchResults;
        context.patchState({
            sort: action.sort,
            searchResults: __spread(searchResults)
        });
    };
    ExploreState.prototype.resetSearchResults = function (context, action) {
        context.patchState({
            searchResults: [],
            checkedSearchResults: []
        });
    };
    ExploreState.prototype.checkSearchResult = function (context, action) {
        var checkedSearchResults = context.getState().checkedSearchResults;
        var exists = checkedSearchResults.some(function (bookmark) { return bookmark === action.id; });
        if (action.checked && !exists) {
            checkedSearchResults = __spread(checkedSearchResults, [action.id]);
        }
        else if (!action.checked) {
            checkedSearchResults = checkedSearchResults.filter(function (bookmark) { return bookmark !== action.id; });
        }
        context.patchState({
            checkedSearchResults: checkedSearchResults
        });
    };
    ExploreState.prototype.setCheckedSearchResults = function (context, action) {
        context.patchState({
            checkedSearchResults: action.ids
        });
    };
    ExploreState.prototype.selectCategory = function (context, _a) {
        var tag = _a.tag;
        context.patchState({
            selectedCategory: categories.find(function (category) { return category.tag === tag; })
        });
    };
    ExploreState.prototype.resetExplore = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(Load),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Load]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "load", null);
    __decorate([
        Action(Search),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Search]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "search", null);
    __decorate([
        Action(SetSearching),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetSearching]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "setSearching", null);
    __decorate([
        Action(LoadSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadSuccess]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "loadSuccess", null);
    __decorate([
        Action(SortSearchResults),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SortSearchResults]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "sortSearchResults", null);
    __decorate([
        Action(ResetSearchResults),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetSearchResults]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "resetSearchResults", null);
    __decorate([
        Action(CheckSearchResult),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckSearchResult]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "checkSearchResult", null);
    __decorate([
        Action(SetCheckedSearchResults),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetCheckedSearchResults]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "setCheckedSearchResults", null);
    __decorate([
        Action(SelectCategory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectCategory]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "selectCategory", null);
    __decorate([
        Action(ResetExplore),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetExplore]),
        __metadata("design:returntype", void 0)
    ], ExploreState.prototype, "resetExplore", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getSearchResults", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getCheckedSearchResults", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getLoading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getSort", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getSelectedCategory", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ExploreStateModel]),
        __metadata("design:returntype", void 0)
    ], ExploreState, "getSearchQuery", null);
    ExploreState = __decorate([
        State({
            name: 'explore',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [ExploreService,
            BookmarksService,
            Store])
    ], ExploreState);
    return ExploreState;
}());
export { ExploreState };
